// extracted by mini-css-extract-plugin
export var addressFields = "_pp-0";
export var animationContainer = "_pp-1";
export var footer = "_pp-2";
export var lineItems = "_pp-3";
export var modalContent = "_pp-4";
export var orderName = "_pp-5";
export var strong = "_pp-6";
export var warning = "_pp-7";